<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

                <v-btn
                    dark
                    text
                    @click="onClickClose"
                >
                    Dismiss
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <p style="margin-top: 15px;">
                <b>Organization</b><br/>
                {{notice.organization_label}}
            </p>

            <p style="margin-top: 15px;">
                <b>Employee</b><br/>
                {{notice.employee_label}} &mdash; ({{notice.employee_username}})
            </p>

            <p style="margin-top: 15px;">
                <b>Creation Time</b><br/>
                {{prettyTime(notice.creation_time)}}
            </p>

            <p style="margin-top: 15px;">
                <b>Type</b><br/>
                {{notice.activity_type}}
            </p>

            <p style="margin-top: 15px;">
                <b>Subject</b><br/>
                {{notice.subject_label}}
            </p>

            <p style="margin-top: 15px;">
                <b>Contact Request Id</b><br/>
                {{notice.contact_request_id}}
            </p>

            <p style="margin-top: 15px;">
                <b>State</b><br/>
                {{notice.state}}
            </p>

            <p style="margin-top: 15px;">
                <b>State Details</b><br/>
                {{notice.state_detail}}
            </p>

            <p style="margin-top: 15px;">
                <b>Sent Message Time</b><br/>
                {{prettyTime(notice.sent_message_time)}}
            </p>

            <p style="margin-top: 15px;">
                <b>Sent Message</b><br/>
                {{notice.sent_message}}
            </p>

            <p style="margin-top: 15px;">
                <b>Sent From</b><br/>
                {{notice.sent_from}}
            </p>

            <p style="margin-top: 15px;">
                <b>Sent To</b><br/>
                {{notice.sent_to}}
            </p>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

const Time = require('@/js/time.js');

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,
            notice: {},
        }
    },

    methods: {

        showDialog(notice)
        {
            this.notice = notice;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // The dialog is showing...
            this.dialog = false;
            next(false);
             
        },

        onClickClose()
        {
            this.dialog = false;
        },

        prettyTime(time)
        {
            if ( time == null ) return '';

            return Time.getTimeAndDate(time);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>